import Vue from 'vue'
import Router from 'vue-router'
import { resolve } from 'url';

Vue.use(Router)
export default new Router({
  mode:'history',
  routes: [
        //pc端口开始
        {
            path:'/',
            redirect:{name:'login'},
        },
        {
            path: '/judge',
            name: 'judge',
            component:resolve => require(['@/view/user/judge'], resolve),
            
        },
        {
            path: '/login',
            name: 'login',
            component:resolve => require(['@/view/user/login'], resolve),
        },
        {
            path: '/user',
            name: 'user',
            component:resolve => require(['@/view/user/UserView'], resolve),
            // redirect: {name:'index'},
            redirect: {name:'year'},
            children: [
                {
                    path: 'year',
                    name: 'year',
                    component:resolve => require(['@/view/user/year'], resolve),
                },
                {
                    path: 'homepage',
                    name: 'homepage',
                    component:resolve => require(['@/view/user/homepage'], resolve),
                    
                },
                {
                    path: 'student',
                    name: 'student',
                    component:resolve => require(['@/view/user/student'], resolve),
                    
                },
                {
                    path: 'Management',
                    name: 'Management',
                    component:resolve => require(['@/view/user/Management'], resolve),
                    
                },
                {
                    path: 'opinions',
                    name: 'opinions',
                    component:resolve => require(['@/view/user/opinions'], resolve),
                    
                },
                {
                    path: 'Learning',
                    name: 'Learning',
                    component:resolve => require(['@/view/user/Learning'], resolve),
                    
                },
                {
                    path: 'work',
                    name: 'work',
                    component:resolve => require(['@/view/user/work'], resolve),
                    
                },
                {
                    path: 'examination',
                    name: 'examination',
                    component:resolve => require(['@/view/user/examination'], resolve),
                    
                },
                {
                    path: 'index',
                    name: 'index',
                    component:resolve => require(['@/view/user/index'], resolve),
                    
                },
                {
                    path: 'message',
                    name: 'message',
                    component:resolve => require(['@/view/user/message'], resolve),
                
                },
                {
                    path: 'register',
                    name: 'register',
                    component:resolve => require(['@/view/user/register'], resolve),
                
                },
                {
                    path: 'reset',
                    name: 'reset',
                    component:resolve => require(['@/view/user/reset'], resolve),
                
                },
            ]
        },
        // 报名pc端
        {
            path: '/newsignup',
            name: 'newsignup',
            component:resolve => require(['@/view/newsignup'], resolve),
        },
        {
            path: '/examine',
            name: 'examine',
            component:resolve => require(['@/view/examine'], resolve),
                
        },
        {
            path: '/success',
            name: 'success',
            component:resolve => require(['@/view/success'], resolve),
                
        },
        
        // 报名手机端
        {
            path: '/newsignupMobile',
            name: 'newsignupMobile',
            component:resolve => require(['@/view/newsignupMobile'], resolve),
        },
        {
            path: '/examineMobile',
            name: 'examineMobile',
            component:resolve => require(['@/view/examineMobile'], resolve),
                
        },
        {
            path: '/successMobile',
            name: 'successMobile',
            component:resolve => require(['@/view/successMobile'], resolve),
                
        },
        //管理端
        {
            path: '/Manage',
            name: 'Manage',
            component:resolve => require(['@/view/Manage'], resolve),
        },
        {
            path: '/home',
            name: 'home',
            component:resolve => require(['@/view/home'], resolve),
        },
        {
            path: '/course',
            name: 'course',
            component:resolve => require(['@/view/course'], resolve),
        },
        {
            path: '/training',
            name: 'training',
            component:resolve => require(['@/view/training'], resolve),
        },
        {
            path: '/staffgl',
            name: 'staffgl',
            component:resolve => require(['@/view/staffgl'], resolve),
        },
        {
            path: '/StudentStyle',
            name: 'StudentStyle',
            component:resolve => require(['@/view/StudentStyle'], resolve),
        },
        {
            path: '/opinion',
            name: 'opinion',
            component:resolve => require(['@/view/opinion'], resolve),
        },
        {
            path: '/Studymaterials',
            name: 'Studymaterials',
            component:resolve => require(['@/view/Studymaterials'], resolve),
        },
        
        
        
   //pc端口结束
  ]
})
// export 



// WEBPACK FOOTER //
// ./src/router/index.js